import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/kriteria-hcu`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/kriteria-hcu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/kriteria-hcu", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/kriteria-hcu/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/kriteria-hcu/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signMasuk(id: number, data: { password: string }) {
  const response = await http
    .postData(`/kriteria-hcu/${id}/sign-masuk`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

//  Blanko 2026: TTD keluar hanya DPJP + PPJA/PJ Shift — TTD perantara
//  "Dokter Jaga / Pengirim" (`sign-keluar`) dicabut beserta rutenya.
async function signChecklistPpja(id: number, data: { password: string }) {
  const response = await http
    .postData(`/kriteria-hcu/${id}/sign-checklist-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signChecklistDpjp(id: number, data: { password: string }) {
  const response = await http
    .postData(`/kriteria-hcu/${id}/sign-checklist-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/kriteria-hcu/${id}/pdf`,
    "_blank"
  );
}

function printPdfMasuk(id: number) {
  window.open(`${http.getAPI()}/kriteria-hcu/${id}/pdf?section=masuk`, "_blank");
}

function printPdfKeluar(id: number) {
  window.open(`${http.getAPI()}/kriteria-hcu/${id}/pdf?section=keluar`, "_blank");
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  signMasuk,
  signChecklistPpja,
  signChecklistDpjp,
  printPdf,
  printPdfMasuk,
  printPdfKeluar,
};
